import { render, staticRenderFns } from "./task-view-details.vue?vue&type=template&id=3fb4f80e&scoped=true&"
import script from "./task-view-details.vue?vue&type=script&lang=js&"
export * from "./task-view-details.vue?vue&type=script&lang=js&"
import style0 from "./task-view-details.vue?vue&type=style&index=0&id=3fb4f80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb4f80e",
  null
  
)

export default component.exports